import {Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as actionsUi from './checklisten.actions.ui';
import {AktuelleChecklisteTypenSetzenAction, PandemieLevelSetzenAction} from './checklisten.actions.ui';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {UuidService} from '@orga-app/providers/uuid.service';
import {ChecklisteLoeschenPage} from '../checkliste-loeschen/checkliste-loeschen.page';
import * as fromChecklistenPage from './checklisten.reducer';
import {PageState} from './checklisten.reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import {getIstPandemieLizenzAktiv, getZeitpunktTexte} from '@orga-app/mandant/reducer';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {ActionSheetController, IonInput, LoadingController, ModalController, NavController, Platform} from '@ionic/angular';
import {Funktionsbereich, FunktionsbereichDetail} from '../../../clients/benutzerverwaltung';
import {
    Aufgabe,
    AufgabeIdListeRequest,
    AufgabeModelRequest,
    AufgabeRequest,
    Checkliste, ChecklisteDetail,
    ChecklisteIdListeRequest,
    ChecklisteModelRequest,
    ChecklisteRequest, ChecklisteVeranstaltungsTypMultiRequest,
    FunktionsbereichChecklisten, ZeitpunktTexte
} from '../../../clients/vorlagen';
import {
    GetChecklisteDetailAction,
    GetFunktionsbereichChecklistenAction,
    GetFunktionsbereicheChecklistenAction,
    PostAufgabeAktualisierenAction,
    PostAufgabeAnlegenAction,
    PostAufgabeKopierenAction,
    PostAufgabeLoeschenAction,
    PostAufgabeReihenfolgenAction,
    PostAufgabeVerschiebenAction,
    PostChecklisteAktualisierenAction,
    PostChecklisteAnlegenAction,
    PostChecklisteKopierenAction,
    PostChecklisteLoeschenAction,
    PostChecklisteReihenfolgenAction, PostChecklisteVeranstaltungsTypenAktivierenAction, PostChecklisteVeranstaltungsTypenDeaktivierenAction, PostChecklisteVeranstaltungsTypenEntfernenAction, PostChecklisteVeranstaltungsTypenHinzufuegenAction,
    PostChecklisteVerschiebenAction
} from '../../../client-ngrx/vorlagen';
import {GetFunktionsbereicheAction} from '../../../client-ngrx/benutzerverwaltung';
import {AufgabePage} from '../aufgabe/aufgabe.page';
import {getTheme} from '@orga-app/settings/reducer';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {RollenselektionPage} from '../rollenselektion/rollenselektion.page';
import {Datenquelle} from '../rollenselektion/rollenselektion.model';
import {ChecklistePandemieLevelInfo} from '../../../clients/pandemie';
import {AufgabePandemieLevel} from './checklisten.models';
import {ItemWrapper, ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {DatenquelleVeranstaltungsTypen} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.model';
import {VeranstaltungstypAuswahlPage} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.page';
import * as apiVeranstaltungen from '../../../clients/veranstaltungen';
import {catchError, filter, takeWhile} from 'rxjs/operators';
import {DocumentService} from '@orga-app/providers/document.service';
import {getPlatform} from '../../operativ/app-state/app-state.reducer';
import {File} from '@ionic-native/file/ngx';
import {DocumentViewer, DocumentViewerOptions} from '@ionic-native/document-viewer/ngx';
import {NotificationService} from '@orga-app/providers/notification.service';
import {FileOpener} from '@ionic-native/file-opener/ngx';
import {BildInfo} from '../../shared/models/bildInfo';
import {of} from 'rxjs';
import {ResponseContentType} from '@angular/http';
import {ImageService} from '@orga-app/providers/image.service';
import {BildVorschauComponent} from '../../../sopi/components/bild-vorschau/bild-vorschau';


@Component({
    selector: 'page-checklisten',
    templateUrl: 'checklisten.page.html',
    styleUrls: ['./checklisten.page.scss']
})

export class ChecklistenPage implements OnInit, OnDestroy {
    @ViewChild('checklisteTitelInput', {static: false}) checklisteTitelInput: IonInput;

    public istPandemieLizenzAktiv$: Observable<boolean>;

    public platformState$: Observable<string>;
    public platformState: string;

    alive = true;

    // FUNKTIONSBEREICHE CHECKLISTEN (LISTE)
    funktionsbereicheChecklistenListeUi$: Observable<Array<ListInputItem>>;
    funktionsbereicheChecklistenListe$: Observable<Array<FunktionsbereichChecklisten>>;
    funktionsbereicheChecklistenListeUiLaden$: Observable<boolean>;
    funktionsbereicheChecklistenListeUiFehler$: Observable<boolean>;
    funktionsbereicheChecklistenListeUiFehlerObjekt$: Observable<any>;
    funktionsbereicheIds$: Observable<Array<string>>;
    funktionsbereicheChecklistenIds$: Observable<Array<string>>;
    funktionsbereicheUndChecklistenIds$: Observable<Array<string>>;

    // FUNKTIONSBEREICHE / CHECKLISTE SELECTIERT
    funktionsbereichListeUiSelektiert$: Observable<Funktionsbereich>;
    checklisteListeUiSelektiert$: Observable<Checkliste>;

    // AUFGABEN (LISTE)
    aufgabeListeUiLaden$: Observable<boolean>;
    aufgabeListeUiFehler$: Observable<boolean>;
    aufgabeListeUiFehlerObjekt$: Observable<any>;
    aufgabeListeUiSelektiert$: Observable<Aufgabe>;

    aufgabenListePandemie$: Observable<Array<ListInputItem>>;

    // FUNKTIONSBEREICHE (DETAIL)
    funktionsbereichDetail$: Observable<FunktionsbereichDetail>;
    funktionsbereichDetailUiLaden$: Observable<boolean>;
    funktionsbereichDetailUiFehler$: Observable<boolean>;
    funktionsbereichDetailUiFehlerObjekt$: Observable<any>;

    // PANDEMIE
    checklistePandemieLevelInfo$: Observable<ChecklistePandemieLevelInfo>;
    checklistePandemieLevelInfoLaden$: Observable<boolean>;
    checklistePandemieLevelInfoFehler$: Observable<boolean>;
    checklistePandemieLevelInfoFehlerObjekt$: Observable<any>;
    aufgabePandemieLevelInfos$: Observable<Array<AufgabePandemieLevel>>;

    // CHECKLISTEN (DETAIL)
    checklisteDetail$: Observable<ChecklisteDetail>;
    checklisteDetailUiLaden$: Observable<boolean>;
    checklisteDetailUiFehler$: Observable<boolean>;
    checklisteDetailUiFehlerObjekt$: Observable<any>;

    veranstaltungsTypen$: Observable<Array<ListInputItem>>;
    veranstaltungsTypenSelected$: Observable<Array<string>>;

    // CHECKLISTE LOESCHEN (COMMANDS)
    checklisteLoeschenCmdUi$: Observable<boolean>;
    checklisteLoeschenCmdUiErfolgreich$: Observable<boolean>;
    checklisteLoeschenCmdUiFehler$: Observable<boolean>;
    checklisteLoeschenCmdUiFehlerObjekt$: Observable<any>;

    // CHECKLISTE ANLEGEN (COMMANDS)
    checklisteAnlegenCmdUi$: Observable<boolean>;
    checklisteAnlegenCmdUiErfolgreich$: Observable<boolean>;
    checklisteAnlegenCmdUiFehler$: Observable<boolean>;
    checklisteAnlegenCmdUiFehlerObjekt$: Observable<any>;

    // CHECKLISTE AKTUALISIEREN (COMMANDS)
    checklisteAktualisierenCmdUi$: Observable<boolean>;
    checklisteAktualisierenCmdUiErfolgreich$: Observable<boolean>;
    checklisteAktualisierenCmdUiFehler$: Observable<boolean>;
    checklisteAktualisierenCmdUiFehlerObjekt$: Observable<any>;

    // AUFGABE LOESCHEN (COMMANDS)
    aufgabeLoeschenCmdUi$: Observable<boolean>;
    aufgabeLoeschenCmdUiErfolgreich$: Observable<boolean>;
    aufgabeLoeschenCmdUiFehler$: Observable<boolean>;
    aufgabeLoeschenCmdUiFehlerObjekt$: Observable<any>;

    // AUFGABE ANLEGEN (COMMANDS)
    aufgabeAnlegenCmdUi$: Observable<boolean>;
    aufgabeAnlegenCmdUiErfolgreich$: Observable<boolean>;
    aufgabeAnlegenCmdUiFehler$: Observable<boolean>;
    aufgabeAnlegenCmdUiFehlerObjekt$: Observable<any>;

    // AUFGABE AKTUALISIEREN (COMMANDS)
    aufgabeAktualisierenCmdUi$: Observable<boolean>;
    aufgabeAktualisierenCmdUiErfolgreich$: Observable<boolean>;
    aufgabeAktualisierenCmdUiFehler$: Observable<boolean>;
    aufgabeAktualisierenCmdUiFehlerObjekt$: Observable<any>;

    // VARIABLEN ZUR ZWISCHENSPEICHERUNG
    uiAktuellerFunktionsbereich: Funktionsbereich; // Zur Anzeige in der View
    aktuellerFunktionsbereich: Funktionsbereich;
    aktuelleCheckliste: Checkliste;
    aktuelleChecklisteModel: ChecklisteDetail;
    aktuelleChecklisteOriginalTitel: string;

    // Berechtigungen
    freigabeRollenSelektiert$: Observable<Array<string>>;
    abarbeitenRollenSelektiert$: Observable<Array<string>>;
    leseRollenSelektiert$: Observable<Array<string>>;

    freigabeRollen$: Observable<Array<ListInputItem>>;
    abarbeitenRollen$: Observable<Array<ListInputItem>>;
    leseRollen$: Observable<Array<ListInputItem>>;

    // AufgabeBilder
    private aufgabeBilder: Array<BildInfo> = new Array<BildInfo>();
    aufgabeBilder$: Observable<Array<BildInfo>>;


    uiAktuelleAufgabe: Aufgabe;
    aktuellerTab = 'Kopfdaten';
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    zeitpunktTexte$: Observable<ZeitpunktTexte>;

    private aiName = 'ChecklistenPage';

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                private storeMandant: Store<fromMandantModule.MandantState>,
                public platform: Platform,
                private uuid: UuidService,
                private store: Store<PageState>,
                public settingsProvider: SettingsProvider,
                private actionSheetCtrl: ActionSheetController,
                private loadingCtrl: LoadingController,
                private documentService: DocumentService,
                public file: File,
                private zone: NgZone,
                public domSanitizer: DomSanitizer,
                private imageService: ImageService,
                private notificationService: NotificationService,
                private documentViewer: DocumentViewer,
                private fileOpener: FileOpener
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.zeitpunktTexte$ = this.store.pipe(select(getZeitpunktTexte));
    }

    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.istPandemieLizenzAktiv$ = this.storeMandant.pipe(select(getIstPandemieLizenzAktiv));

        // Platform from State
        this.platformState$ = this.store.pipe(select(getPlatform));

        // FUNKTIONSBEREICHE CHECKLISTEN (LISTE)
        this.funktionsbereicheChecklistenListeUi$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenListeUi));

        this.funktionsbereicheChecklistenListe$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenListe));
        this.funktionsbereicheChecklistenListeUiLaden$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenListeUiLaden));
        this.funktionsbereicheChecklistenListeUiFehler$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenListeUiFehler));
        this.funktionsbereicheChecklistenListeUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenListeUiFehlerObjekt));
        this.funktionsbereicheIds$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheIds));
        this.funktionsbereicheChecklistenIds$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheChecklistenIds));
        this.funktionsbereicheUndChecklistenIds$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereicheUndChecklistenIds));
        // FUNKTIONSBEREICH / CHECKLISTE SELECTED
        this.funktionsbereichListeUiSelektiert$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereichListeUiSelektiert));
        this.checklisteListeUiSelektiert$ = this.store.pipe(select(fromChecklistenPage.getChecklisteListeUiSelektiert));

        // AUFGABEN (LISTE)
        // this.aufgabeListe$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListe));
        this.aufgabeListeUiLaden$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListeUiLaden));
        this.aufgabeListeUiFehler$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListeUiFehler));
        this.aufgabeListeUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListeUiFehlerObjekt));
        this.aufgabeListeUiSelektiert$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListeUiSelektiert));

        this.aufgabenListePandemie$ = this.store.pipe(select(fromChecklistenPage.getAufgabeListePandemie));

        // PANDEMIE
        this.checklistePandemieLevelInfo$ = this.store.pipe(select(fromChecklistenPage.getChecklistePandemieLevelInfo));
        this.checklistePandemieLevelInfoLaden$ = this.store.pipe(select(fromChecklistenPage.getChecklistePandemieLevelInfoLaden));
        this.checklistePandemieLevelInfoFehler$ = this.store.pipe(select(fromChecklistenPage.getChecklistePandemieLevelInfoFehler));
        this.checklistePandemieLevelInfoFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getChecklistePandemieLevelInfoFehlerObjekt));
        this.aufgabePandemieLevelInfos$ = this.store.pipe(select(fromChecklistenPage.getAufgabePandemieLevel));

        // FUNKTIONSBEREICHE (DETAIL)
        this.funktionsbereichDetail$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereichDetail));
        this.funktionsbereichDetailUiLaden$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereichDetailUiLaden));
        this.funktionsbereichDetailUiFehler$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereichDetailUiFehler));
        this.funktionsbereichDetailUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getFunktionsbereichDetailUiFehlerObjekt));

        // CHECKLISTEN (DETAIL)
        this.checklisteDetail$ = this.store.pipe(select(fromChecklistenPage.getChecklisteDetail));
        this.checklisteDetailUiLaden$ = this.store.pipe(select(fromChecklistenPage.getChecklisteDetailUiLaden));
        this.checklisteDetailUiFehler$ = this.store.pipe(select(fromChecklistenPage.getChecklisteDetailUiFehler));
        this.checklisteDetailUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getChecklisteDetailUiFehlerObjekt));

        this.veranstaltungsTypen$ = this.store.pipe(select(fromChecklistenPage.getVeranstaltungsTypen));
        this.veranstaltungsTypenSelected$ = this.store.pipe(select(fromChecklistenPage.getVeranstaltungsTypenSelected));

        // CHECKLISTE LOESCHEN (COMMANDS)
        this.checklisteLoeschenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getChecklisteLoeschenCmdUi));
        this.checklisteLoeschenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getChecklisteLoeschenCmdUiErfolgreich));
        this.checklisteLoeschenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getChecklisteLoeschenCmdUiFehler));
        this.checklisteLoeschenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getChecklisteLoeschenCmdUiFehlerObjekt));

        // CHECKLISTE ANLEGEN (COMMANDS)
        this.checklisteAnlegenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAnlegenCmdUi));
        this.checklisteAnlegenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAnlegenCmdUiErfolgreich));
        this.checklisteAnlegenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAnlegenCmdUiFehler));
        this.checklisteAnlegenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAnlegenCmdUiFehlerObjekt));

        // CHECKLISTE AKTUALISIEREN (COMMANDS)
        this.checklisteAktualisierenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAktualisierenCmdUi));
        this.checklisteAktualisierenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAktualisierenCmdUiErfolgreich));
        this.checklisteAktualisierenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAktualisierenCmdUiFehler));
        this.checklisteAktualisierenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getChecklisteAktualisierenCmdUiFehlerObjekt));

        // AUFGABEN LOESCHEN (COMMANDS)
        this.aufgabeLoeschenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getAufgabeLoeschenCmdUi));
        this.aufgabeLoeschenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getAufgabeLoeschenCmdUiErfolgreich));
        this.aufgabeLoeschenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getAufgabeLoeschenCmdUiFehler));
        this.aufgabeLoeschenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getAufgabeLoeschenCmdUiFehlerObjekt));

        // AUFGABEN ANLEGEN (COMMANDS)
        this.aufgabeAnlegenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAnlegenCmdUi));
        this.aufgabeAnlegenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAnlegenCmdUiErfolgreich));
        this.aufgabeAnlegenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAnlegenCmdUiFehler));
        this.aufgabeAnlegenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAnlegenCmdUiFehlerObjekt));

        // AUFGABEN AKTUALISIEREN (COMMANDS)
        this.aufgabeAktualisierenCmdUi$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAktualisierenCmdUi));
        this.aufgabeAktualisierenCmdUiErfolgreich$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAktualisierenCmdUiErfolgreich));
        this.aufgabeAktualisierenCmdUiFehler$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAktualisierenCmdUiFehler));
        this.aufgabeAktualisierenCmdUiFehlerObjekt$ = this.store.pipe(select(fromChecklistenPage.getAufgabeAktualisierenCmdUiFehlerObjekt));

        // Berechtigungen
        this.freigabeRollenSelektiert$ = this.store.pipe(select(fromChecklistenPage.getFreigabeRollenSelektiert));
        this.abarbeitenRollenSelektiert$ = this.store.pipe(select(fromChecklistenPage.getAbarbeitenRollenSelektiert));
        this.leseRollenSelektiert$ = this.store.pipe(select(fromChecklistenPage.getLeseRollenSelektiert));

        this.freigabeRollen$ = this.store.pipe(select(fromChecklistenPage.getFreigabeRollen));
        this.abarbeitenRollen$ = this.store.pipe(select(fromChecklistenPage.getAbarbeitenRollen));
        this.leseRollen$ = this.store.pipe(select(fromChecklistenPage.getLeseRollen));

        this.funktionsbereichListeUiSelektiert$.subscribe(x => {
            this.aktuellerFunktionsbereich = x;
        });

        this.checklisteDetail$.subscribe(x => {
            if (x != null) {
                this.aktuelleCheckliste = Object.assign({}, x);
                this.aktuelleChecklisteModel = Object.assign({}, x);
                this.aktuelleChecklisteOriginalTitel = x.titel;
            } else {
                this.aktuelleCheckliste = null;
                this.aktuelleChecklisteModel = null;
                this.aktuelleChecklisteOriginalTitel = '';
            }
        });


        this.aufgabeListeUiSelektiert$.subscribe(x => {
            if (x != null) {
                this.uiAktuelleAufgabe = x;
            }
            while (this.aufgabeBilder.length > 0) {
                this.aufgabeBilder.pop();
            }
            this.zone.run(() => {
                this.aufgabeBilder = [];
                this.aufgabeBilder$ = of(this.aufgabeBilder);
            });

            if (x != null && x.bild_ids !== undefined && x.bild_ids !== null && x.bild_ids.length > 0) {

                x.bild_ids.forEach(bildId => {
                    this.getAufgabeBild(x.aufgabe_id, bildId)
                        .pipe(
                            takeWhile(() => this.alive)
                            , filter(image => {
                                return !!image;
                            }),
                            catchError((error: any) => {
                                console.debug('ERROR :: ', error);
                                return of();
                            }),
                        )
                        .subscribe((image: BlobPart) => {
                                const imgtype = bildId.split('.')[1];
                                if (image) {
                                    const blob = new Blob([image]);

                                    const reader = new FileReader();
                                    reader.onload = function () {
                                        const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                                        const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];

                                        const bi = <BildInfo>{
                                            bildId,
                                            data: imgBase64JPEG,
                                            dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                                            type: 'image/' + imgtype
                                        };

                                        if (this.aufgabeBilder.findIndex(bild => bild.bildId === bildId) === -1) {
                                            this.zone.run(() => {
                                                this.aufgabeBilder.push(bi);
                                                this.aufgabeBilder$ = of(this.aufgabeBilder);
                                            });
                                        }

                                    }.bind(this);

                                    reader.readAsDataURL(blob);
                                }
                            },
                            error => {

                            });
                });
            }
        });

        this.platformState$.subscribe(x => {
            this.platformState = x;
            if (x === 'desktop') {
                this.viewWillEnterPage().then();
            }
        }).unsubscribe();

        this.funktionsbereicheLaden();
        this.funktionsbereicheChecklistenLaden();
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.funktionsbereicheUndChecklisteLaden();
    }

    getAufgabeBild(aufgabeId: string, bildId: string): Observable<any> {
        const requestOptions = {
            responseType: ResponseContentType.Blob
        };
        return this.imageService.getAufgabeVorlageBildWithHttpInfo(aufgabeId, bildId, requestOptions);
    }

    async aufgabeBilderAnzeigen(index) {
        const imageModal = await this.modalCtrl.create({
            component: BildVorschauComponent,
            componentProps: {
                bilder: this.aufgabeBilder$,
                initialImage: index,
                title: 'Vorlagenbilder'
            },
        });
        imageModal.onDidDismiss().then(data => console.debug('AufgabePage:: aufgabeBilderAnzeigen :  imageModal.onDidDismiss: ' + data));
        await imageModal.present();
    }

    async funktionsbereicheUndChecklisteLaden() {
        this.funktionsbereicheChecklistenLaden();
        await this.aktuelleChecklisteLaden();
    }

    async aktuelleChecklisteLaden() {
        await this.checklisteLaden(this.aktuelleCheckliste, this.aktuelleCheckliste);
    }

    funktionsbereicheLaden() {
        this.store.dispatch(new GetFunktionsbereicheAction());
    }

    funktionsbereicheChecklistenLaden() {
        this.store.dispatch(new GetFunktionsbereicheChecklistenAction(false));
    }


    /* CHECKLISTEN */
    checklistenLaden() {
        if (this.uiAktuellerFunktionsbereich != null && this.uiAktuellerFunktionsbereich.funktionsbereich_id != null) {
            this.store.dispatch(new actionsUi.AktuelleChecklisteSetzenAction(null));
            this.store.dispatch(new actionsUi.AktuellenFunktionsbereichSetzenAction(this.uiAktuellerFunktionsbereich));
            this.store.dispatch(new GetFunktionsbereichChecklistenAction(this.uiAktuellerFunktionsbereich.funktionsbereich_id));
        }
    }

    async checklisteLadenSopiListe($event: { checkliste: Checkliste, funktionsbereich: Funktionsbereich }) {
        await this.checklisteLaden($event.checkliste, $event.funktionsbereich);
    }

    async checklisteLaden(checkliste: Checkliste, funktionsbereich: Funktionsbereich) {
        if (checkliste != null && checkliste.checkliste_id != null) {
            this.store.dispatch(new actionsUi.AktuelleChecklisteSetzenAction(checkliste));
            this.store.dispatch(new GetChecklisteDetailAction(checkliste.checkliste_id));
            setTimeout(() => {
                if (this.checklisteTitelInput !== null && this.checklisteTitelInput !== undefined) {
                    this.checklisteTitelInput.setFocus();
                }
            }, 500);
        }

        this.uiAktuellerFunktionsbereich = funktionsbereich;
        this.store.dispatch(new actionsUi.AktuellenFunktionsbereichSetzenAction(this.uiAktuellerFunktionsbereich));
    }

    neueCheckliste(funktionsbereich: Funktionsbereich) {
        if (funktionsbereich !== null && funktionsbereich.funktionsbereich_id !== null) {
            const checkliste = <Checkliste>{
                checkliste_id: null,
                funktionsbereich_id: funktionsbereich.funktionsbereich_id,
                titel: '',
                freigabe_rollen_ids: [],
                abarbeitung_rollen_ids: [],
                lese_rollen_ids: []
            };
            this.aktuellerTab = 'Kopfdaten';
            this.store.dispatch(new actionsUi.NeueChecklisteAction(checkliste, funktionsbereich));
            setTimeout(() => {
                if (this.checklisteTitelInput !== null && this.checklisteTitelInput !== undefined) {
                    this.checklisteTitelInput.setFocus();
                }
            }, 500);
        }
    }

    checklisteAktualisierenOderHinzufuegen() {
        if (this.aktuelleChecklisteModel.titel !== this.aktuelleChecklisteOriginalTitel) {
            if (this.aktuelleCheckliste.checkliste_id === null || this.aktuelleCheckliste.checkliste_id === undefined) {
                const uuid = this.uuid.generateUUID();
                this.aktuelleChecklisteModel.checkliste_id = uuid;

                const request = <ChecklisteModelRequest>{
                    titel: this.aktuelleChecklisteModel.titel,
                    freigabe_rollen_ids: this.aktuelleChecklisteModel.freigabe_rollen_ids,
                    abarbeitung_rollen_ids: this.aktuelleChecklisteModel.abarbeitung_rollen_ids,
                    lese_rollen_ids: this.aktuelleChecklisteModel.lese_rollen_ids,
                    zeitpunkt_utc: new Date(Date.now()),
                    checkliste_id: this.aktuelleChecklisteModel.checkliste_id,
                    funktionsbereich_id: this.aktuelleChecklisteModel.funktionsbereich_id,
                };

                this.store.dispatch(new PostChecklisteAnlegenAction(request));
            } else {
                this.checklisteSpeichern();
            }
        }
    }

    checklisteSpeichern() {
        const request = <ChecklisteModelRequest>{
            titel: this.aktuelleChecklisteModel.titel,
            freigabe_rollen_ids: this.aktuelleChecklisteModel.freigabe_rollen_ids,
            abarbeitung_rollen_ids: this.aktuelleChecklisteModel.abarbeitung_rollen_ids,
            lese_rollen_ids: this.aktuelleChecklisteModel.lese_rollen_ids,
            zeitpunkt_utc: new Date(Date.now()),
            reihenfolge: this.aktuelleChecklisteModel.reihenfolge,
            checkliste_id: this.aktuelleChecklisteModel.checkliste_id,
            funktionsbereich_id: this.aktuelleChecklisteModel.funktionsbereich_id,
        };

        this.store.dispatch(new PostChecklisteAktualisierenAction(request));
        // this.store.dispatch(new actionsUi.AktuelleChecklisteSetzenAction(checkliste));

        // this.checklistenReihenfolgeSenden();
    }

    async checklisteEntfernen() {
        if (this.aktuellerFunktionsbereich !== null && this.aktuellerFunktionsbereich.funktionsbereich_id !== null && this.aktuelleCheckliste != null
            && this.aktuelleCheckliste.checkliste_id != null) {
            const param = {titel: this.aktuelleCheckliste.titel};
            const modal = await this.modalCtrl.create({component: ChecklisteLoeschenPage, componentProps: param});
            modal.onDidDismiss().then(result => {
                if (result != null && result.data) {
                    const request = <ChecklisteRequest>{
                        checkliste_id: this.aktuelleCheckliste.checkliste_id,
                        funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                        zeitpunkt_utc: new Date(Date.now())
                    };
                    this.store.dispatch(new PostChecklisteLoeschenAction(request));
                }
            });

            await modal.present();
        }
    }

    async checklisteKopieren() {
        if (this.aktuelleCheckliste) {
            const request = <ChecklisteRequest>{
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostChecklisteKopierenAction(request));
        }
    }


    /* BERECHTIGUNGEN */
    async abarbeitenBerechtigungRollenAuswahl() {
        if (this.aktuelleCheckliste != null && this.aktuelleChecklisteModel != null) {
            const params = {
                titel: this.aktuelleChecklisteModel.titel,
                nichtAnzuzeigendeRollenIds: this.aktuelleChecklisteModel.abarbeitung_rollen_ids,
                funktionsbereich: this.aktuellerFunktionsbereich,
                checkliste: this.aktuelleCheckliste,
                untertitel: 'Abarbeiten-Berechtigung',
                alleAnzeigenAuswahlAnzeigen: true,
                alleAnzeigen: false,
                datenquelle: Datenquelle.Vorlagen
            };
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    result.data.ausgewaehlteRollen.forEach((x: string) => {
                        if (this.aktuelleChecklisteModel.abarbeitung_rollen_ids == null) {
                            this.aktuelleChecklisteModel.abarbeitung_rollen_ids = [];
                        }
                        const listeRollen = Object.assign([], this.aktuelleChecklisteModel.abarbeitung_rollen_ids);
                        listeRollen.push(x);
                        this.aktuelleChecklisteModel.abarbeitung_rollen_ids = Object.assign([], listeRollen);
                    });

                    this.checklisteSpeichern();
                }
            });

            await modal.present();
        }
    }

    async freigabeBerechtigungRollenAuswahl() {
        if (this.aktuelleCheckliste != null && this.aktuelleChecklisteModel != null) {
            const params = {
                titel: this.aktuelleChecklisteModel.titel,
                nichtAnzuzeigendeRollenIds: this.aktuelleChecklisteModel.freigabe_rollen_ids,
                funktionsbereich: this.aktuellerFunktionsbereich,
                checkliste: this.aktuelleCheckliste,
                untertitel: 'Freigabe-Berechtigung',
                alleAnzeigenAuswahlAnzeigen: true,
                alleAnzeigen: false,
                datenquelle: Datenquelle.Vorlagen
            };
            // console.log('Params: ', params);
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    console.log('REsult: ', result);
                    result.data.ausgewaehlteRollen.forEach((x: string) => {
                        if (this.aktuelleChecklisteModel.freigabe_rollen_ids == null) {
                            this.aktuelleChecklisteModel.freigabe_rollen_ids = [];
                        }
                        const listeFreigabeRollen = Object.assign([], this.aktuelleChecklisteModel.freigabe_rollen_ids);
                        listeFreigabeRollen.push(x);
                        this.aktuelleChecklisteModel.freigabe_rollen_ids = Object.assign([], listeFreigabeRollen);
                    });

                    this.checklisteSpeichern();
                }
            });

            await modal.present();
        }
    }

    async leseBerechtigungRollenAuswahl() {
        if (this.aktuelleCheckliste != null && this.aktuelleChecklisteModel != null) {
            const params = {
                titel: this.aktuelleChecklisteModel.titel,
                nichtAnzuzeigendeRollenIds: this.aktuelleChecklisteModel.lese_rollen_ids,
                funktionsbereich: this.aktuellerFunktionsbereich,
                checkliste: this.aktuelleCheckliste,
                untertitel: 'Lese-Berechtigung',
                alleAnzeigenAuswahlAnzeigen: true,
                alleAnzeigen: false,
                datenquelle: Datenquelle.Vorlagen
            };
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    result.data.ausgewaehlteRollen.forEach((x: string) => {
                        if (this.aktuelleChecklisteModel.lese_rollen_ids == null) {
                            this.aktuelleChecklisteModel.lese_rollen_ids = [];
                        }
                        const listeRollen = Object.assign([], this.aktuelleChecklisteModel.lese_rollen_ids);
                        listeRollen.push(x);
                        this.aktuelleChecklisteModel.lese_rollen_ids = Object.assign([], listeRollen);
                    });

                    this.checklisteSpeichern();
                }
            });

            await modal.present();
        }
    }

    abarbeitenRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new actionsUi.AbarbeitenRollenSetzenAction($event));
    }

    leseRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new actionsUi.LeseRollenSetzenAction($event));
    }

    freigabeRollenSelectionChanged($event: Array<string>) {
        this.store.dispatch(new actionsUi.FreigabeRollenSetzenAction($event));
    }

    freigabeBerechtigungFuerRolleLoeschen() {
        this.store.dispatch(new actionsUi.FreigabeRollenLoeschenAction());

        // this.checklistenReihenfolgeSenden();
    }

    abarbeitenBerechtigungFuerRolleLoeschen() {
        this.store.dispatch(new actionsUi.AbarbeitenRollenLoeschenAction());

        // this.checklistenReihenfolgeSenden();
    }


    leseBerechtigungFuerRolleLoeschen() {
        this.store.dispatch(new actionsUi.LeseRollenLoeschenAction());

        // this.checklistenReihenfolgeSenden();
    }

    trackByChecklistenItem(index, item: ItemWrapper) {
        return item.id + item.selected;
    }


    /* AUFGABEN */
    async neueAufgabeAnlegen() {
        if (this.aktuelleCheckliste !== null && this.aktuelleChecklisteModel !== null && this.aktuelleChecklisteModel.titel !== null
            && this.aktuellerFunktionsbereich !== null && this.aktuelleCheckliste !== null) {
            const params = {
                aufgabe: null,
                titel: '',
                funktionsbereich: this.aktuellerFunktionsbereich,
                checkliste: this.aktuelleCheckliste,
                untertitel: 'Neue Aufgabe anlegen',
                veranstaltungsId: null
            };
            const modal = await this.modalCtrl.create({component: AufgabePage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    const uuid = this.uuid.generateUUID();
                    // const request = <AufgabeModelRequest> {
                    //     titel: result.data.aufgabe.titel,
                    //     aufgabe: result.data.aufgabe,
                    //     aufgabe_id: uuid,
                    //     checkliste_id: this.aktuelleCheckliste.checkliste_id,
                    //     funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                    //     zeitpunkt_utc: new Date(Date.now())
                    // };
                    const request = <AufgabeModelRequest>{
                        titel: result.data.aufgabe.titel,
                        beschreibung: result.data.aufgabe.beschreibung,
                        ist_optional: result.data.aufgabe.ist_optional,
                        optional_standard_aktiviert: result.data.aufgabe.optional_standard_aktiviert,
                        ist_veranstaltungsrelevant: result.data.aufgabe.ist_veranstaltungsrelevant,
                        reihenfolge: 0,

                        referenz_zeitpunkt: result.data.aufgabe.referenz_zeitpunkt,
                        relation: result.data.aufgabe.relation,

                        // Erinnerung
                        ist_erinnerung_aktiv: result.data.aufgabe.ist_erinnerung_aktiv,
                        ist_erinnerung_uhrzeit_fix: result.data.aufgabe.ist_erinnerung_uhrzeit_fix,
                        ist_erinnerung_wochentag_fix: result.data.aufgabe.ist_erinnerung_wochentag_fix,
                        erinnerung_relativ_minuten: result.data.aufgabe.erinnerung_relativ_minuten,
                        erinnerung_relativ_tage: result.data.aufgabe.erinnerung_relativ_tage,
                        erinnerung_uhrzeit_fix_stunden: result.data.aufgabe.erinnerung_uhrzeit_fix_stunden,
                        erinnerung_uhrzeit_fix_minuten: result.data.aufgabe.erinnerung_uhrzeit_fix_minuten,
                        erinnerung_fix_wochentag: result.data.aufgabe.erinnerung_fix_wochentag,

                        // Eskalation
                        ist_eskalation_aktiv: result.data.aufgabe.ist_eskalation_aktiv,
                        ist_eskalation_uhrzeit_fix: result.data.aufgabe.ist_eskalation_uhrzeit_fix,
                        ist_eskalation_wochentag_fix: result.data.aufgabe.ist_eskalation_wochentag_fix,
                        eskalation_relativ_minuten: result.data.aufgabe.eskalation_relativ_minuten,
                        eskalation_relativ_tage: result.data.aufgabe.eskalation_relativ_tage,
                        eskalation_uhrzeit_fix_stunden: result.data.aufgabe.eskalation_uhrzeit_fix_stunden,
                        eskalation_uhrzeit_fix_minuten: result.data.aufgabe.eskalation_uhrzeit_fix_minuten,
                        eskalation_fix_wochentag: result.data.aufgabe.eskalation_fix_wochentag,
                        ist_eskalation_an_freigeber_funktionsbereich_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_funktionsbereich_aktiv,
                        ist_eskalation_an_freigeber_checkliste_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_checkliste_aktiv,
                        ist_eskalation_an_abarbeiter_aktiv: result.data.aufgabe.ist_eskalation_an_abarbeiter_aktiv,
                        ist_eskalation_an_veranstaltungsleiter_aktiv: result.data.aufgabe.ist_eskalation_an_veranstaltungsleiter_aktiv,

                        aufgabe_id: uuid,
                        checkliste_id: this.aktuelleCheckliste.checkliste_id,
                        funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                        zeitpunkt_utc: new Date(Date.now()),
                        bild_ids: result.data.aufgabe.bild_ids
                    };
                    this.store.dispatch(new PostAufgabeAnlegenAction(request));
                }
            });

            await modal.present();
        }
    }

    async aufgabeBearbeiten() {
        const aktuelleAufgabe: Aufgabe = this.uiAktuelleAufgabe;
        const params = {
            aufgabe: aktuelleAufgabe,
            titel: this.aktuelleChecklisteModel.titel,
            funktionsbereich: this.aktuellerFunktionsbereich,
            checkliste: this.aktuelleCheckliste,
            untertitel: 'Aufgabe bearbeiten',
            veranstaltungsId: null
        };
        const modal = await this.modalCtrl.create({component: AufgabePage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            // console.log('xxxxxxx', result);
            if (result != null && result.data) {
                console.log('xxxxxxx2', result);
                const uuid = this.uuid.generateUUID();

                const request = <AufgabeModelRequest>{
                    titel: result.data.aufgabe.titel,
                    beschreibung: result.data.aufgabe.beschreibung,
                    ist_optional: result.data.aufgabe.ist_optional,
                    optional_standard_aktiviert: result.data.aufgabe.optional_standard_aktiviert,
                    ist_veranstaltungsrelevant: result.data.aufgabe.ist_veranstaltungsrelevant,
                    reihenfolge: result.data.aufgabe.reihenfolge,

                    referenz_zeitpunkt: result.data.aufgabe.referenz_zeitpunkt,
                    relation: result.data.aufgabe.relation,

                    // Erinnerung
                    ist_erinnerung_aktiv: result.data.aufgabe.ist_erinnerung_aktiv,
                    ist_erinnerung_uhrzeit_fix: result.data.aufgabe.ist_erinnerung_uhrzeit_fix,
                    ist_erinnerung_wochentag_fix: Boolean(result.data.aufgabe.ist_erinnerung_wochentag_fix),
                    erinnerung_relativ_minuten: result.data.aufgabe.erinnerung_relativ_minuten,
                    erinnerung_relativ_tage: result.data.aufgabe.erinnerung_relativ_tage,
                    erinnerung_uhrzeit_fix_stunden: result.data.aufgabe.erinnerung_uhrzeit_fix_stunden,
                    erinnerung_uhrzeit_fix_minuten: result.data.aufgabe.erinnerung_uhrzeit_fix_minuten,
                    erinnerung_fix_wochentag: result.data.aufgabe.erinnerung_fix_wochentag,

                    // Eskalation
                    ist_eskalation_aktiv: result.data.aufgabe.ist_eskalation_aktiv,
                    ist_eskalation_uhrzeit_fix: result.data.aufgabe.ist_eskalation_uhrzeit_fix,
                    ist_eskalation_wochentag_fix: Boolean(result.data.aufgabe.ist_eskalation_wochentag_fix),
                    eskalation_relativ_minuten: result.data.aufgabe.eskalation_relativ_minuten,
                    eskalation_relativ_tage: result.data.aufgabe.eskalation_relativ_tage,
                    eskalation_uhrzeit_fix_stunden: result.data.aufgabe.eskalation_uhrzeit_fix_stunden,
                    eskalation_uhrzeit_fix_minuten: result.data.aufgabe.eskalation_uhrzeit_fix_minuten,
                    eskalation_fix_wochentag: result.data.aufgabe.eskalation_fix_wochentag,
                    ist_eskalation_an_freigeber_funktionsbereich_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_funktionsbereich_aktiv,
                    ist_eskalation_an_freigeber_checkliste_aktiv: result.data.aufgabe.ist_eskalation_an_freigeber_checkliste_aktiv,
                    ist_eskalation_an_abarbeiter_aktiv: result.data.aufgabe.ist_eskalation_an_abarbeiter_aktiv,
                    ist_eskalation_an_veranstaltungsleiter_aktiv: result.data.aufgabe.ist_eskalation_an_veranstaltungsleiter_aktiv,

                    aufgabe_id: aktuelleAufgabe.aufgabe_id,
                    checkliste_id: this.aktuelleCheckliste.checkliste_id,
                    funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                    zeitpunkt_utc: new Date(Date.now()),
                    bild_ids: result.data.aufgabe.bild_ids
                };
                this.store.dispatch(new PostAufgabeAktualisierenAction(request));
            }
        });

        modal.present();
    }


    async aufgabeLoeschen() {
        if (this.uiAktuelleAufgabe !== null && this.uiAktuelleAufgabe.aufgabe_id !== null && this.aktuellerFunktionsbereich !== null
            && this.aktuellerFunktionsbereich.funktionsbereich_id !== null) {
            const aktuelleAufgabe: Aufgabe = this.uiAktuelleAufgabe;
            const request = <AufgabeRequest>{
                aufgabe_id: aktuelleAufgabe.aufgabe_id,
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostAufgabeLoeschenAction(request));
        }
    }

    async aktuelleAufgabeSetzen(aufgabe: Aufgabe) {
        await this.store.dispatch(new actionsUi.AktuelleAufgabeSetzenAction(aufgabe));
        // this.uiAktuelleAufgabe = aufgabe;
    }

    async titleSetzen($event: CustomEvent) {
        this.aktuelleChecklisteModel.titel = $event.detail.value;
    }

    async aufgabeKopieren() {
        if (this.uiAktuelleAufgabe !== null && this.uiAktuelleAufgabe.aufgabe_id !== null && this.aktuellerFunktionsbereich !== null
            && this.aktuellerFunktionsbereich.funktionsbereich_id !== null) {
            const aktuelleAufgabe: Aufgabe = this.uiAktuelleAufgabe;
            const request = <AufgabeRequest>{
                aufgabe_id: aktuelleAufgabe.aufgabe_id,
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostAufgabeKopierenAction(request));
        }
    }

    async dropInCheckliste($event: CdkDragDrop<any>, item: any) {
        await this.dropInChecklisteNew({event: $event, item: item});
    }

    async dropInChecklisteNew(data: {event: CdkDragDrop<any>, item: any}) {
        const item = data.item;
        const $event = data.event;
        console.log($event.item.data);
        if (item !== null && $event.item.data && $event.item.data.model === 'Aufgabe' && $event.item.data.item.checkliste_id !== item.checkliste_id) {
            const aktuelleAufgabe: Aufgabe = $event.item.data.item;
            const request = <AufgabeRequest>{
                aufgabe_id: aktuelleAufgabe.aufgabe_id,
                checkliste_id: item.checkliste_id,
                funktionsbereich_id: item.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostAufgabeVerschiebenAction(request));
        }

        // Verschieben einer Checkliste in einen FB ohne Checklisten
        if (item !== null && item.checkliste_id === undefined && $event.item.data && $event.item.data.model === 'Checkliste') {
            const aktuelleCheckliste: Checkliste = $event.item.data.item;

            // VERSCHIEBEN
            const requestChecklisteVerschieben = <ChecklisteRequest>{
                position: 0,
                checkliste_id: aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: item.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostChecklisteVerschiebenAction(requestChecklisteVerschieben));
        }

        // Verschieben einer Checkliste in einen FB mit Checklisten und mit Einsortierung
        if (item !== null && item.checkliste_id !== undefined && $event.item.data && $event.item.data.model === 'Checkliste' && $event.item.data.item.checkliste_id !== item.checkliste_id) {
            const aktuelleCheckliste: Checkliste = $event.item.data.item;

            // Checkliste einordnen
            this.funktionsbereicheChecklistenListe$.subscribe(fbCl => {
                    const fb: Array<FunktionsbereichChecklisten> = fbCl.filter((x) => x.funktionsbereich.funktionsbereich_id === item.funktionsbereich_id);
                    if (fb.length === 1) {
                        const checklisten = [...fb[0].checklisten].filter(cl => cl.checkliste_id !== aktuelleCheckliste.checkliste_id); // zu verschiebende CL rausfiltern für das umsortieren
                        const droppedOnChecklistIndex = checklisten.findIndex(x => x.checkliste_id === item.checkliste_id);
                        const droppedOnChecklist = checklisten[droppedOnChecklistIndex];
                        if ($event.item.data.item.funktionsbereich_id === droppedOnChecklist.funktionsbereich_id) {
                            // UMSORTIEREN
                            checklisten.splice(droppedOnChecklistIndex, 0, aktuelleCheckliste);
                            const checklisteIdListeRequest = <ChecklisteIdListeRequest>{
                                checkliste_ids: checklisten.map(x => x.checkliste_id),
                                funktionsbereich_id: item.funktionsbereich_id,
                            };
                            this.store.dispatch(new PostChecklisteReihenfolgenAction(checklisteIdListeRequest));
                        } else {
                            // VERSCHIEBEN
                            const requestChecklisteVerschieben = <ChecklisteRequest>{
                                position: droppedOnChecklist.reihenfolge + 1,
                                checkliste_id: aktuelleCheckliste.checkliste_id,
                                funktionsbereich_id: item.funktionsbereich_id,
                                zeitpunkt_utc: new Date(Date.now())
                            };
                            this.store.dispatch(new PostChecklisteVerschiebenAction(requestChecklisteVerschieben));
                        }
                    }
                }
            ).unsubscribe();
        }
    }

    async dropInAufgabenListe($event: CdkDragDrop<any>) {
        await this.dropInAufgabenListeNeu({event: $event, item: null});
    }

    async dropInAufgabenListeNeu(data: {event: CdkDragDrop<any>, item: any}) {
        const $event = data.event;
        // console.log($event);
        this.aufgabenListePandemie$.subscribe(items => {
            const aufgaben = [...items.map(x => x.item)];
            moveItemInArray(aufgaben, $event.previousIndex, $event.currentIndex);
            const aufgabenIds = aufgaben.map(aufgabe => aufgabe.aufgabe.aufgabe_id);
            const request = <AufgabeIdListeRequest>{
                aufgabe_ids: aufgabenIds,
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
            };
            this.store.dispatch(new PostAufgabeReihenfolgenAction(request));
        }).unsubscribe();
    }

    async checklistenReihenfolgeSenden() {
        this.funktionsbereicheChecklistenListe$.subscribe(fbCl => {
                const fb: Array<FunktionsbereichChecklisten> = fbCl.filter((x) => x.funktionsbereich.funktionsbereich_id === this.aktuelleChecklisteModel.funktionsbereich_id);
                if (fb.length === 1) {
                    const checklisten = [...fb[0].checklisten];
                    const checklisteIdListeRequest = <ChecklisteIdListeRequest>{
                        checkliste_ids: checklisten.map(x => x.checkliste_id),
                        funktionsbereich_id: this.aktuelleChecklisteModel.funktionsbereich_id,
                    };
                    // console.log(checklisteIdListeRequest);
                    this.store.dispatch(new PostChecklisteReihenfolgenAction(checklisteIdListeRequest));
                }
            }
        ).unsubscribe();
    }

    trackByItem(index, item: any) {
        return item.id + item.selected;
    }

    changeLevel($event: CustomEvent, level: AufgabePandemieLevel) {
        this.store.dispatch(new PandemieLevelSetzenAction(level, $event.detail.checked));
    }

    typzuordnungSpeichern() {

    }

    changetyp($event: CustomEvent, dokumentDetail: any) {
    }

    trackByAufgabeItem(index, item: ItemWrapper) {
        return item.id + item.selected;
    }

    changeVeranstaltungsTypenAktiv($event) {
        if ($event.detail.checked === true) {
            const request = <ChecklisteRequest>{
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                position: 0,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostChecklisteVeranstaltungsTypenAktivierenAction(request));
        } else if ($event.detail.checked === false) {
            const request = <ChecklisteRequest>{
                checkliste_id: this.aktuelleCheckliste.checkliste_id,
                funktionsbereich_id: this.aktuellerFunktionsbereich.funktionsbereich_id,
                position: 0,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostChecklisteVeranstaltungsTypenDeaktivierenAction(request));
        }
    }

    typenEntfernen(typen: any, detail: ChecklisteDetail) {
        const request: ChecklisteVeranstaltungsTypMultiRequest = {
            checkliste_id: detail.checkliste_id,
            funktionsbereich_id: detail.funktionsbereich_id,
            position: 0,
            typ_ids: typen
        };
        this.store.dispatch(new PostChecklisteVeranstaltungsTypenEntfernenAction(request));
    }

    async typenHinzufuegen(detail: ChecklisteDetail) {
        const typenIds: Array<string> = [];
        detail.veranstaltungstyp_liste.forEach(item => typenIds.push(item.veranstaltungstyp_id));
        const params = {
            titel: detail.titel,
            nichtAnzuzeigendeTypenIds: typenIds,
            untertitel: 'Typen-Berechtigung für Checkliste',
            datenquelle: DatenquelleVeranstaltungsTypen.VeranstaltungsTypen,
            enableSingleSelection: false
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: VeranstaltungstypAuswahlPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                result.data.ausgewaehlteTypen.forEach((x: string) => {
                    const request: ChecklisteVeranstaltungsTypMultiRequest = {
                        checkliste_id: detail.checkliste_id,
                        funktionsbereich_id: detail.funktionsbereich_id,
                        position: 0,
                        typ_ids: result.data.ausgewaehlteTypen
                    };
                    this.store.dispatch(new PostChecklisteVeranstaltungsTypenHinzufuegenAction(request));
                });
            }
        });

        await modal.present();
    }

    typenGewaehlt($event: any) {
        this.store.dispatch(new AktuelleChecklisteTypenSetzenAction($event));
    }

    async aufgabeExportieren(aufgabe: apiVeranstaltungen.Aufgabe) {
        const buttons = [
            {
                text: 'Gruppiert nach Veranstaltung',
                handler: () => {
                    this.aufgabeBerichtOeffnen(aufgabe, 1);
                }
            },
            {
                text: 'als Buchungsliste',
                handler: () => {
                    this.aufgabeBerichtOeffnen(aufgabe, 2);
                }
            },
            {text: 'Abbrechen',
            icon: 'close',
            role: 'cancel'}
        ];

        const actionSheet = await this.actionSheetCtrl.create({
            header: 'Wähle eine Variante',
            backdropDismiss: true,
            buttons
        });
        await actionSheet.present();
    }

    async aufgabeBerichtOeffnen(aufgabe: apiVeranstaltungen.Aufgabe, variante: number) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Bericht ' + variante + ' für Aufgabe ' + aufgabe.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/veranstaltungen-reporting/aufgabe/tracing/' + aufgabe.aufgabe_id + '/pdf?reportVersion=' + variante.toString();
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    if (this.platformState === 'desktop') {
                        this.documentService.saveFile(doc, this.replaceSpecialCharacter(aufgabe.titel));
                    } else {
                        this.file.removeFile(this.file.dataDirectory, this.replaceSpecialCharacter(aufgabe.titel) + '-' + variante + '.pdf').then((x) => {
                            this.writeFile(aufgabe, doc, variante);
                        }).catch((error) => {
                            this.writeFile(aufgabe, doc, variante);
                        });
                    }

                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });
    }

    async writeFile(aufgabe: apiVeranstaltungen.Aufgabe, doc, variante) {
        const options: DocumentViewerOptions = {
            title: aufgabe.titel,
            documentView: {closeLabel: 'Schließen'},
            openWith: {enabled: true},
            email: {enabled: true}
        };
        const filename = this.replaceSpecialCharacter(aufgabe.titel) + '-' + variante + '.pdf';

        // let x = Observable.fromPromise(this.file.writeFile(this.file.dataDirectory, dokument.dokument_id + '.pdf', document))
        const y = Observable.fromPromise(this.file.writeFile(this.file.dataDirectory, filename, doc))
            .subscribe((x) => {
                if (this.platform.is('ios')) {
                    const cacheDirectory = this.file.dataDirectory.replace('file://', '');
                    this.documentViewer.viewDocument(cacheDirectory + filename, 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                } else {
                    this.fileOpener.open(
                        this.file.dataDirectory + filename,
                        'application/pdf'
                    ).then(() => console.debug('File is opened'))
                        .catch(e => {
                            console.debug('Error opening file', e);
                            this.documentViewer.viewDocument(this.file.dataDirectory + filename, 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                        });
                }
            }, (error) => {
                console.error(error);
                this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
            });
    }

    async onShowDocument() {
    }

    async onCloseDocument() {
    }

    async onMissingApp(appId, installer) {
        if (confirm('Um das PDF ansehen zu können wird die kostenfreie PDF Viewer App benötigt. Jetzt installieren?')) {
            installer();
        }
    }

    async onErrorDocument(error) {
        window.console.error(error);
        await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
    }

    replaceSpecialCharacter(value: string) {
        return value
            .replace(/ /g, '_')
            .replace(/ä/g, 'ae')
            .replace(/Ä/g, 'Ae')
            .replace(/ü/g, 'ue')
            .replace(/Ü/g, 'Ue')
            .replace(/ö/g, 'oe')
            .replace(/Ö/g, 'Oe')
            .replace(/ß/g, 'ss')
            .replace(/\//g, '-')
            .replace(/\\/g, '-')
            ;
    }

    ngOnDestroy(): void {
        this.alive = false;
    }
}
